import { queryDictList } from "@/api/dict";
import { ref, onMounted } from "vue";

export default function useSystemList() {
  const systemList = ref([]);

  const getList = () => {
    queryDictList("process_system").then((res) => {
      systemList.value = res.data || [];
    });
  };

  onMounted(() => {
    getList();
  });

  return {
    systemList,
  };
}
